import { FC } from "react";
import Modal from "../../Modal";
import styles from "./MobileMenu.module.scss";
import ModalContent from "../../Modal/ModalContent";
import { useModal } from "@hooks/useModal";
import { useWallet } from "@stores/wallet.store";
import { Link } from "react-router-dom";

interface Props {
    isVisible: boolean;
    setIsVisible(isViisble: boolean): void;
    showDisconnectModal(): void;
    showDepositModal(): void;
    showRefferalModal(): void;
    showConnectModal(): void;
}

const MobileMenu: FC<Props> = ({
    isVisible,
    setIsVisible,
    showDepositModal,
    showRefferalModal,
    showDisconnectModal,
    showConnectModal,
}) => {
    const [_, handleClose] = useModal(setIsVisible);
    const isWalletConnected = useWallet((state) => state.isConnected);

    return (
        <Modal isVisible={isVisible} setIsVisible={setIsVisible}>
            <ModalContent classNames={styles.content}>
                <div className={styles.header}>
                    <h2 className={styles.headline}>Menu</h2>
                    <button className={styles.close} onClick={handleClose}>
                        <picture>
                            <source
                                srcSet="/images/modal/closemobile.svg"
                                width={7.5}
                                height={7.5}
                                media="(max-width: 768px)"
                            />
                            <img
                                height={12}
                                width={12}
                                src="/images/modal/close.svg"
                                style={{ opacity: 0.4 }}
                                alt="Close modal"
                            />
                        </picture>
                    </button>
                </div>
                <div className={styles.buttons}>
                    <button onClick={showDepositModal} className={styles.button}>
                        <span>Deposit</span>
                        <div className={styles.image}>
                            <img width={18} height={18} src="/images/profile/deposit.svg" alt="" />
                        </div>
                    </button>
                    {isWalletConnected ? (
                        <button onClick={showConnectModal} className={styles.button}>
                            <span>Connect wallet</span>
                            <div className={styles.image}>
                                <img width={12} height={12} src="/images/profile/plus.svg" alt="" />
                            </div>
                        </button>
                    ) : (
                        <button onClick={showDisconnectModal} className={styles.button}>
                            <span>Disconnect wallet</span>
                            <div className={styles.image}>
                                <img width={12} height={12} src="/images/profile/close.svg" alt="" />
                            </div>
                        </button>
                    )}
                    <Link to="/pricing" className={styles.button}>
                        <span>Pricing</span>
                        <div className={styles.image}>
                            <img width={16} height={16} src="/images/profile/subscribe.svg" alt="" />
                        </div>
                    </Link>
                    <button onClick={showRefferalModal} className={styles.button}>
                        <span>Referrals</span>
                        <div className={styles.image}>
                            <img width={18} height={18} src="/images/profile/referals.svg" alt="" />
                        </div>
                    </button>
                </div>
            </ModalContent>
        </Modal>
    );
};

export default MobileMenu;
